import React from 'react';
import PropTypes from 'prop-types';

import { Image } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleTwoImage = ({
    image1 = {},
    image2 = {},
    caption,
}) => {

    if (!image1 && !image2) { return null; }

    return (
        <figure className='module-two-image w-full flex flex-wrap md:flex-row-reverse'>
            <div className='w-6/12 md:w-5/12 px-10 sm:px-20'>
                {image1?.contentType?.includes('video/') ? (
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        src={image1?.src}
                        width={'100%'}/>
                ) : <Image
                    loadWidth={581}
                    {...image1} />
                }
            </div>
            <div className='w-6/12 md:w-5/12 px-10 sm:px-20'>
                {image2?.contentType?.includes('video/') ? (
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        src={image2?.src}
                        width={'100%'}/>
                ) : <Image
                    loadWidth={581}
                    {...image2}/>
                }
            </div>
            {!!caption &&
                <figcaption className='w-full sm:w-4/6 md:w-2/12 type-style-7 text-dark-grey whitespace-pre-wrap mt-20 md:mt-0 px-10 sm:px-20'>
                    {caption}
                </figcaption>
            }
        </figure>
    );

};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

ModuleTwoImage.propTypes = {
    caption: PropTypes.string,
    image1: PropTypes.shape({
        src: PropTypes.string.isRequired
    }).isRequired,
    image2: PropTypes.shape({
        src: PropTypes.string.isRequired
    }).isRequired,
};

export default ModuleTwoImage;
